import React, { useEffect, useState } from 'react';

/**
 * Countdown "3 · 2 · 1 · FIGHT!" until `startsAt` (local ms) and a big caption (`banner`)
 * for K.O. / TIME. Pure presentation.
 */
export function useCountdown(startsAt) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!startsAt) return undefined;
    setNow(Date.now());
    // ticks only around the countdown, then stops re-rendering
    const id = setInterval(() => {
      const t = Date.now();
      setNow(t);
      if (t > startsAt + 1000) clearInterval(id);
    }, 100);
    return () => clearInterval(id);
  }, [startsAt]);
  return startsAt ? startsAt - now : -Infinity;
}

export default function FightOverlay({ startsAt, banner, startLabel = 'FIGHT!' }) {
  const left = useCountdown(startsAt);
  let text = null;
  let cls = '';
  if (banner) {
    text = banner;
    cls = 'is-banner';
  } else if (left > 0) {
    text = String(Math.ceil(left / 1000));
    cls = 'is-count';
  } else if (left > -700) {
    text = startLabel;
    cls = 'is-go';
  }
  if (!text) return null;
  return (
    <div className="bo" aria-live="polite">
      <div key={text} className={`bo-text ${cls}`}>{text}</div>
    </div>
  );
}
